import { Nav } from '@/marketing/blocks/nav';
import { Footer } from '@/marketing/blocks/footer';
import { PackStoreSection } from '@/marketing/blocks/pack-store-section';
import { WaitlistSection } from '@/marketing/blocks/waitlist-section';

export default function Store() {
  return (
    <>
      <Nav ctaPrimary="" />
      <PackStoreSection />
      <WaitlistSection />
      <Footer />
    </>
  );
}
